import { render, staticRenderFns } from "./SinistreSuccess.vue?vue&type=template&id=e9bbb0d4&scoped=true"
import script from "./SinistreSuccess.vue?vue&type=script&lang=js"
export * from "./SinistreSuccess.vue?vue&type=script&lang=js"
import style0 from "./SinistreSuccess.vue?vue&type=style&index=0&id=e9bbb0d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bbb0d4",
  null
  
)

export default component.exports